import jQuery from 'jquery';
export default (hash, sub) => (e) => {
	if(e){
		e.preventDefault();
	}
	if (!hash) return; 
	const el = document.querySelector(hash);
	var top = el.offsetTop - document.querySelector('header nav').offsetHeight;
	if(sub){
		top -= sub;
	}
	jQuery("body, html").animate({scrollTop: top}, 600);
}


// WEBPACK FOOTER //
// ./src/helpers/scroll-to.js